module.exports = "precision mediump float;\n\nuniform mat4 proj;\nuniform mat4 model;\nuniform mat4 view;\n\nattribute vec3 position;\n\nvarying vec3 worldSpaceCoords;\n\nvoid main()\n{\n  worldSpaceCoords = position + vec3(0.5, 0.5, 0.5);\n  gl_Position = proj * view * model * vec4(position, 1.0);\n}\n"


//////////////////
// WEBPACK FOOTER
// ./shaders/first-pass.vert.glsl
// module id = 57
// module chunks = 0